const prescription = {
  preOrderMessage: 'Pre-order medicines with a',
  scanned: 'Scanned',
  uploaded: 'Uploaded',
  noteToPharmacy: 'Note to pharmacy',
  yourComment: 'Your comment ...',
}

export default prescription
